export default __webpack_public_path__ + "static/media/img-0321-madagascar-half-face.8779f9cf.png";